import { useSearchParams } from "react-router-dom";

const ORDER_ID_SEARCH_PARAM = "orderId";

const useOrderDetailSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const orderId = searchParams.get(ORDER_ID_SEARCH_PARAM);
  const orderDetailSearchParams = { orderId };

  const setOrderDetailSearchParams = ({ orderId }: { orderId: string }) => {
    const newSearchParams = { [ORDER_ID_SEARCH_PARAM]: orderId };
    setSearchParams(newSearchParams, { replace: true });
  };

  return { orderDetailSearchParams, setOrderDetailSearchParams };
};

export default useOrderDetailSearchParams;
